var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFacebookWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_facebook",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0065719,0 L0.9934281,0 C0.4447159,0 0,0.4446484 0,0.9934281 L0,17.0065719 C0,17.5552167 0.4447159,18 0.9934281,18 L9.6143338,18 L9.6143338,11.0294799 L7.268616,11.0294799 L7.268616,8.3128958 L9.6143338,8.3128958 L9.6143338,6.3095161 C9.6143338,3.9845707 11.0343357,2.7186074 13.1083277,2.7186074 C14.1017558,2.7186074 14.9556453,2.7925918 15.2044407,2.8256386 L15.2044407,5.2553223 L13.766027,5.2559968 C12.6380511,5.2559968 12.4196722,5.7919624 12.4196722,6.5784768 L12.4196722,8.3128958 L15.1097514,8.3128958 L14.7594551,11.0294799 L12.4196722,11.0294799 L12.4196722,18 L17.0065719,18 C17.5552167,18 18,17.5552167 18,17.0065719 L18,0.9934281 C18,0.4446484 17.5552167,0 17.0065719,0",
    id: "Imported-Layers-Copy"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacebookWhite);
export default __webpack_public_path__ + "static/media/logo_facebook_white.530191bb2f4196399dff2b91c6216491.svg";
export { ForwardRef as ReactComponent };